import 'slick-carousel';
import WOW from 'wow.js';
export default {
  init() {
    // JavaScript to be fired on all pages
    $(document).ready(function() {
      if (document.referrer == null || document.referrer.indexOf(window.location.hostname) < 0) {
        $('header.header .menu__container .menu__item').addClass('animated fadeIn');
        $('body.home img.logo').addClass('animated fadeInDown');
      }
      //Video
      $('img.video__player').click(function() {
        var video = '<iframe src="' + $(this).attr('data-video') + '"></iframe>';
        $(this).replaceWith(video);
      });

      //Slick
      if ($(window).width() <= 600) {
        $('.news__container').slick("unslick");
      }
      $('.news__container').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        arrows: false,
        responsive: [{
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        }],
      });
      $('.article__container:first').addClass('first');
      $('section.news .btn__container .slick__button.next').click(function() {
        $('section.news .btn__container .slick__button.prev').addClass('show');
      });
      if ($('.news__container.slick-slider .article__container.first').hasClass('slick-current')) {
        $('section.news .btn__container .slick__button.prev').removeClass('show');
      }
      $('.slick__button .prev').click(function() {
        $('.news__container').slick('slickPrev');
      });
      $('.slick__button .next').click(function() {
        $('.news__container').slick('slickNext');
      });
      //News Hovers
      $('.news__container a.article__container').on("hover", function(){
         $(this).find('.content__hover').fadeToggle(400);
      });
      // $('.news__container a.article__container').mouseenter(function() {
      //   $(this).find('article .content .content__hover').fadeIn(400);
      // });
      // $('.news__container a.article__container').mouseleave(function() {
      //   $(this).find('article .content .content__hover').fadeOut(400);
      // });
      // WOW JS
      new WOW().init();
      //Sidebar Image Pop up
      setTimeout(function() {
        $('.interior__archive .sidebar .sidebar__wrapper').addClass('popup');
      }, 3000);
      setTimeout(function() {
        $('.interior__archive .sidebar .sidebar__wrapper').removeClass('popup');
      }, 5000);

      //Social Media Hovers
      if ($(window).width() >= 960) {
        $('.social__box a').on('mouseenter', function() {
          $(this).find('img.desktop').hide();
          $(this).find('img.desktop__hover').show();
          $(this).find('.content .btn__white--border').addClass('fill');
        });
        $('.social__box a').on('mouseleave', function() {
          $(this).find('img.desktop').show();
          $(this).find('img.desktop__hover').hide();
          $(this).find('.content .btn__white--border').removeClass('fill');
        });
      }
      //Event Box
      $('.event__box a.btn__blue--border:contains("Sold Out")').addClass("sold__out--btn");

       if ($(window).width() >= 768) {
          $('.event__box.mobile').remove();
          $('.event__box.tablet').remove();
       }
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js